import { Injectable } from '@angular/core';
import { arrayNotEmpty } from 'class-validator';
import { BasicResponse } from 'src/app/core/models/basic-response.model';
import { getConnection } from 'src/app/core/services/functions.service';
import { QueriesService } from 'src/app/core/services/queries.service';
import { UsuarioAuth } from 'src/app/modules/auth/models/auth.models';
import { AuthService } from 'src/app/modules/auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  private TABLA_PRINCIPAL: string = "usuarios_sicf"
  private TABLA_AGENCIAS: string = "agencia"

  constructor(
    private queriesService: QueriesService,
    private authService: AuthService,
  ) { }

  async findAll(): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL)
      .select("usuario_aplicativo usuario", "(CASE WHEN clave_encriptada IS NULL THEN 'NO TIENE' WHEN clave_encriptada IS NOT NULL THEN 'SI TIENE' END) clave", "estado")
      .orderBy("usuario_aplicativo asc")
      .execute()
    return result
  }
  async findAllAgencies(): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_AGENCIAS)
      .select("c_age", "(c_age || ' - ' || nom) nom")
      .where(`act = 'S' AND c_emp = '${getConnection()}'`)
      .orderBy(this.TABLA_AGENCIAS + ".nom asc")
      .execute()
    return result
  }
  async findOne(usuario_aplicativo: string): Promise<BasicResponse> {
    const result = await this.queriesService.table(this.TABLA_PRINCIPAL).where({ usuario_aplicativo }).execute()
    result.data = arrayNotEmpty(result.data) ? result.data[0] : null
    return result
  }

  async create(value: UsuarioAuth): Promise<BasicResponse> {
    const id = (await this.queriesService.table(this.TABLA_PRINCIPAL).select("(TO_CHAR(max(id)) + 1) as id").execute()).data[0].id
    value.id = Number(id) + ""
    const result = await this.authService.register(value)
    return result
  }

  async update(value: UsuarioAuth) {
    const result = await this.authService.modify(value)
    return result
  }


}
